'use strict'

import Vue from 'vue'
import axios from 'axios'
import { Message, Loading } from 'element-ui'
import router from '../router'
import pathConfig from '@/config/requirePath'

let pendingAjax = []
const CancelToken = axios.CancelToken

let config = {
  baseURL: '/api', // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 15000 // request timeout
}
let loading = null

const _axios = axios.create(config)

_axios.interceptors.request.use(
  config => {

    let url = config.baseURL + config.url
    const index = pendingAjax.findIndex(i => i.url === url)
    if (index > -1) {
      let message = "请求的太快啦！"
      pendingAjax[index].c(message)
      pendingAjax.splice(index, 1)
    }
    if (config.repeat) {
      console.log(url)
      config.cancelToken = new CancelToken(c => {
        pendingAjax.push({
          url,
          c
        })
      })
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error, error.config)
  }
)

// Add a response interceptor
_axios.interceptors.response.use(
  response => {

    let url = response.config.url
    const index = pendingAjax.findIndex(i => i.url === url)
    if (index > -1) {
      pendingAjax.splice(index, 1)
    }

    const ret = response.data.ret

    if (ret === 1 || response.data.reply === 1) {
      return Promise.resolve(response.data, response)
    } else {
      if (response.data.msg == "cookie中没有user_token" || response.data.msg == "没有登录") {
        console.log(pathConfig.loginPath)
        window.location.href = pathConfig.loginPath;
      } else {
        Message.error(response.data.msg)
      }

      return Promise.reject(response.data, response)
    }
  },
  error => {
    console.log(error) // for debug
    if (error.config) {
      let url = error.config.url
      const index = pendingAjax.findIndex(i => i.url === url)
      if (index > -1) {
        pendingAjax.splice(index, 1)
      }
    }
    // 断网 或者 请求超时 状态
    if (!error.response) {
      // 请求超时状态
      if (error.message.includes('timeout')) {
        Message.error('请求超时，请检查网络是否连接正常')
      } else if (axios.isCancel(error)) {
        console.log('Request canceled', error.message);
      } else {
        // 可以展示断网组件
        Message.error('请求失败，请检查网络是否已连接')
      }
    } else {
      const responseCode = error.response.status
      switch (responseCode) {
        case 404:
          Message({
            message: '网络请求不存在',
            type: 'error'
          })
          break
        // 其他错误，直接抛出错误提示
        default:
          Message({
            message: error.response.data.message,
            type: 'error'
          })
      }
    }
    return Promise.reject(error, error.config)
  }
)

Plugin.install = function (Vue, options) {
  Vue.axios = _axios
  window.axios = _axios
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios
      }
    },
    $axios: {
      get() {
        return _axios
      }
    }
  })
}

Vue.use(Plugin)

export default Plugin


